import { render } from "./ModalEnviarARealizar.vue?vue&type=template&id=50834387&scoped=true"
import script from "./ModalEnviarARealizar.vue?vue&type=script&lang=js"
export * from "./ModalEnviarARealizar.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&id=50834387&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50834387"]])

export default __exports__